import * as React from "react"
import colors from "../../theme/colors"

const LinkedIn: React.SFC<{ hovered?: boolean }> = ({ hovered = false }) => (
  <svg width={36} height={36}>
    <g fill="none" fillRule="evenodd">
      <path
        fill={
          hovered
            ? colors.main.accentColor.PRIMARY
            : colors.main.backgroundColor.PRIMARY
        }
        d="M0 0h36v36H0z"
      />
      <g fill={colors.main.textColor.PRIMARY}>
        <path d="M10.65 31V14.132H5.314V31h5.334zM7.981 11.829c1.86 0 3.018-1.296 3.018-2.914C10.965 7.259 9.842 6 8.018 6 6.193 6 5 7.26 5 8.915c0 1.618 1.157 2.914 2.947 2.914h.035zM14 31h5.57v-9.276c0-.496.035-.992.182-1.347.403-.992 1.32-2.02 2.858-2.02 2.015 0 2.821 1.524 2.821 3.757V31H31v-9.524C31 16.374 28.252 14 24.588 14c-3.004 0-4.323 1.665-5.056 2.799h.037v-2.41H14C14.073 15.95 14 31 14 31z" />
      </g>
    </g>
  </svg>
)

export default LinkedIn
